/* import __COLOCATED_TEMPLATE__ from './activation-resent.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./activation-resent.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());